import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxHolidayHourComponent } from './nx-holiday-hour.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxHolidayHourComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxHolidayHourComponent
  ]
})
export class NxHolidayHourModule { }
